import React, {useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import LightGreenButton from '../Buttons/LightGreenButton';
import s from './ErrorFallback.module.css';

type ErrorFallbackProps = {
	onReset?: () => void;
	error?: Error | null;
	errorInfo?: React.ErrorInfo | null;
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
	onReset,
	error,
	errorInfo,
}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();

	const handleGoHome = () => {
		onReset?.();
		navigate('/');
	};

	const handleReload = () => {
		onReset?.();
		window.location.reload();
	};

	/*const showDiagnostics = useMemo(
		() => process.env.NODE_ENV !== 'production' && (error || errorInfo),
		[error, errorInfo],
	);*/

	return (
		<div className={s.container} role="alert" aria-live="assertive">
			<div className={s.card}>
				<div className={s.illustration} aria-hidden="true">
					<span>!</span>
				</div>
				{/*<h1 className={s.title}>{t('От халепа!')}</h1>*/}
				<p className={s.description}>
					{t(
						'Схоже, щось пішло не так. Ми вже отримали сигнал про помилку. Спробуйте оновити сторінку або поверніться на головну.',
					)}
				</p>
				<div className={s.actions}>
					<LightGreenButton
						onClick={handleReload}
						text={t('Спробувати ще раз')}
						type="button"
						className={s.primaryButton}
					/>
					<LightGreenButton
						onClick={handleGoHome}
						text={t('Повернутися на головну')}
						type="button"
						className={s.primaryButton}
					/>
				</div>
				{/*{showDiagnostics && (
					<details className={s.diagnostics}>
						<summary>{t('Деталі для підтримки')}</summary>
						<div className={s.diagnosticsContent}>
							{error?.message && (
								<p>
									<strong>{t('Повідомлення')}:</strong> {error.message}
								</p>
							)}
							{errorInfo?.componentStack && (
								<pre>{errorInfo.componentStack.trim()}</pre>
							)}
						</div>
					</details>
				)}*/}
			</div>
		</div>
	);
};

export default ErrorFallback;
